import React, { FC, useState, useEffect } from 'react';
import { up } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import BodyText from '@fenderdigital/ui/BodyText';
import LoadingPlaceHolder from './LoadingPlaceholder/LoadingPlaceHolder';
import SearchResultsContent from './SearchResultsContent';
import { SearchSelectionProvider } from '../../../contexts/SearchSelectionContext';
import { EventNames } from '../../../lib/analytics';
import { Facets } from '../../../models/search';
// eslint-disable-next-line max-len

import * as S from './SearchResults-styled';

export interface SearchResultsProps {
  results?: any[] | null;
  isLoading?: boolean;
  query: string;
  onClose: () => void;
  facets?: Facets;
  instrument: string;
  onCategoryChange: (arg0: string) => void;
}

interface Stats {
  riffs: number;
  songs: number;
  skills: number;
}

type Artists = {
  name: string;
};

interface TrackEvent {
  eventType: EventNames;
  properties: any;
  options: any;
  callback: () => void;
}

export interface Results {
  image: string;
  slug: string;
  title: string;
  stats: Stats;
  instrument: string;
  artists?: Artists[];
  level?: string;
  url?: string;
  type?: string;
  objectType: string;
  trackEvent: TrackEvent;
}

const SearchResults: FC<SearchResultsProps> = ({
  results,
  isLoading,
  query,
  onClose,
  facets,
  instrument,
  onCategoryChange,
}) => {
  const [totalResults, setTotalResults] = useState(0);
  const isTabletUp = useBreakpoint(up('tablet-portrait'));

  useEffect(() => {
    let resultSum = 0;
    if (results) {
      results.forEach(result => {
        resultSum += result.items.length;
      });
    }
    setTotalResults(resultSum);
  }, [results]);

  return (
    <SearchSelectionProvider>
      <S.Container data-id="search-results-container">
        <S.MetaWrapper>
          {isLoading ? (
            <LoadingPlaceHolder />
          ) : (
            <SearchResultsContent
              facets={facets}
              instrument={instrument}
              onCategoryChange={onCategoryChange}
              totalResults={totalResults}
              onClose={onClose}
              query={query}
              results={results}
            />
          )}
        </S.MetaWrapper>
        {isTabletUp && totalResults ? (
          <S.ButtonContainer>
            <S.Button to={`/search?query=${query}`} onClick={onClose}>
              <BodyText fontFamily="futuraDemi" textSize="f3" textColor="white" alignment="center">
                See all results
              </BodyText>
            </S.Button>
          </S.ButtonContainer>
        ) : null}
      </S.Container>
      <S.Overlay onClick={onClose} />
    </SearchSelectionProvider>
  );
};

export default SearchResults;
